export const isValidUrl = (value) => {
  if (!value.trim()) return false;
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
  return urlRegex.test(value);
};
